module.exports = __webpack_public_path__ + "static/media/fanyuvo-event1.ed4e3832.jpg";